export default {
  root: {
    padding: '16px 74px',
  }
};
